var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMouth4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 39,
    viewBox: "0 0 60 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100_5825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.904 5.21713V8.54582C59.904 18.408 55.1316 27.1555 47.7698 32.6014C42.8 36.2784 36.6535 38.4537 29.9961 38.4537C23.3388 38.4537 17.1962 36.2784 12.2263 32.6014C4.86453 27.1555 0.0921173 18.408 0.0921173 8.54582V5.21713C0.0921173 1.98133 3.07245 -0.453256 6.23471 0.235705C17.7109 2.73609 42.2852 2.73609 53.7614 0.235705C56.9237 -0.453256 59.904 1.98133 59.904 5.21713Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.904 5.21713V8.19359C52.1822 9.79601 40.9769 11.6926 31.2695 11.6926C17.4632 11.6926 4.32265 7.85685 0.0921173 6.49441V5.21713C0.0921173 1.98133 3.07245 -0.453256 6.23471 0.235705C17.7109 2.73609 42.2852 2.73609 53.7614 0.235705C56.9237 -0.453256 59.904 1.98133 59.904 5.21713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7698 32.6012C42.8 36.2782 36.6535 38.4535 29.9961 38.4535C23.3387 38.4535 17.1962 36.2782 12.2263 32.6012C14.0146 24.3994 21.2912 18.2568 30 18.2568C38.7088 18.2568 45.9816 24.3994 47.7698 32.6012Z",
    fill: "#B63131"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100_5825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 38.8889,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouth4);
export default __webpack_public_path__ + "static/media/mouth-4.8fe5eb9e3e3c5a6fd2599e0c02928681.svg";
export { ForwardRef as ReactComponent };